// (function () {
// 	'use strict';

//     angular.module("imApp").factory("brRegViewService", ['$ihttp', function ($ihttp) {
// 		let service = {
//             getEdit: function (parms) {
//                 return $ihttp.post({
//                     method: 1310,
//                     parameters: parms || {}
//                 });
//             },
//             saveObj: function (edit) {
//                 return $ihttp.post({
//                     method: 1311,
//                     parameters: edit
//                 });
//             }
// 		};

// 		return service;
// 	}]);
// })();
